<div class="chart-card">
  <h4 class="chart-title">{{ 'Overview' | translate }} {{ selectedYear }}</h4>
  @if (loading) {
    <div class="chart-loading">
      <mat-spinner [diameter]="28"></mat-spinner>
    </div>
  } @else if (hasData) {
    <div echarts [options]="chartOptions" [autoResize]="true" class="chart"></div>
  } @else {
    <p class="chart-empty">{{ 'No data for this year' | translate }}</p>
  }
</div>
